import { useMemo } from 'react';

export function useDashboardMetrics(source, maps) {
  return useMemo(() => {
    const extract = keysMap =>
      Object.entries(source)
        .filter(([key]) => key in keysMap)
        .map(([key, value]) => ({
          title: keysMap[key],
          value
        }));

    return Object.fromEntries(Object.entries(maps).map(([name, map]) => [name, extract(map)]));
  }, [source, maps]);
}
